import { request } from './index'
import { RsaEncrypt } from '@/utils/index'
interface CustomOptions {
  rsa_encrypt_show?: boolean
  baseAxiosURL?: string
}
export const defHttp = {
  get: (options: any, customOptions: CustomOptions = {}) => {
    return request({ method: 'get', ...options }, customOptions)
  },
  post: (options: any, customOptions: CustomOptions = {}) => {
    const data = {
      data: RsaEncrypt(encodeURI(JSON.stringify(options.data))),
      timestamp: Date.now(),
    }
    return request({
      method: 'post',
      ...options,
      data: customOptions.rsa_encrypt_show ? data : options.data,
    },customOptions)
  },
  put: (options: any, customOptions: CustomOptions = {}) => {
    const data = {
      data: RsaEncrypt(encodeURI(JSON.stringify(options.data))),
      timestamp: Date.now(),
    }
    return request({
      method: 'put',
      ...options,
      data: customOptions.rsa_encrypt_show ? data : options.data,
    },customOptions)
  },
  delete: (options: any, customOptions: CustomOptions = {}) => {
    return request({ method: 'delete', ...options }, customOptions)
  },
}
